// 全局的store
import common from './common';

export default {
  common,
};
